import { createContext, useContext } from 'react';
import { InputGroupDividerVariant, InputGroupSize, InputGroupStatus } from './types';

export interface InputGroupContextValue {
  size: InputGroupSize;
  disabled: boolean;
  status?: InputGroupStatus;
  dividerVariant: InputGroupDividerVariant;
  /**
   * 이 자리의 왼쪽 여백. 필드 가장자리면 필드 좌우 패딩이고, 부모 그룹의 구분선과 맞닿는 자리면 부모의 칸 사이 여백이다.
   */
  startSpacing: number;
  /** 이 자리의 오른쪽 여백. 규칙은 `startSpacing`과 같다. */
  endSpacing: number;
  /** 이 자리가 필드(가장 바깥 그룹)의 왼쪽 끝에 닿아 있는지 */
  atFieldStart: boolean;
  /** 이 자리가 필드의 오른쪽 끝에 닿아 있는지 */
  atFieldEnd: boolean;
}

/**
 * 패키지 밖으로 export하지 않습니다.
 */
export const InputGroupContext = createContext<InputGroupContextValue | null>(null);

export const useInputGroupContext = () => useContext(InputGroupContext);
